var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuildingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Building") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Building",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mbri-home",
    transform: "translate(4.000000, 5.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11,0.733333333 C10.9516,0.736266667 10.8848667,0.748 10.8408667,0.77 L0.205333333,5.89893333 C-0.236866667,6.1116 0.1122,6.75693333 0.5236,6.5604 L11,1.507 L21.4764,6.56113333 C21.9039333,6.76646667 22.2288,6.10793333 21.7946667,5.89966667 L11.1591333,0.77 C11.1034,0.742866667 11.0616,0.7304 11,0.733333333 Z M1.83333333,7.33333333 C1.63093333,7.33626667 1.46373333,7.4976 1.46666667,7.7 L1.46666667,18.7 C1.46666667,19.3028 1.96386667,19.8 2.56666667,19.8 L7.7,19.8 C7.9024,19.8 8.06666667,19.6357333 8.06666667,19.4333333 L8.06666667,13.9355333 C8.06666667,12.3053333 9.36833333,11.0036667 11,11.0036667 C12.6316667,11.0036667 13.9333333,12.3053333 13.9333333,13.9355333 L13.9333333,19.4333333 C13.9333333,19.6357333 14.0976,19.8 14.3,19.8 L19.4333333,19.8 C20.0361333,19.8 20.5333333,19.3028 20.5333333,18.7 L20.5333333,7.70513333 C20.5333333,7.227 19.8,7.2094 19.8,7.70513333 L19.8,18.7 C19.8,18.9097333 19.6430667,19.0666667 19.4333333,19.0666667 L14.6666667,19.0666667 L14.6666667,13.9355333 C14.6666667,11.9115333 13.024,10.2710667 11,10.2710667 C8.976,10.2710667 7.33333333,11.9115333 7.33333333,13.9355333 L7.33333333,19.0666667 L2.56666667,19.0666667 C2.35693333,19.0666667 2.2,18.9097333 2.2,18.7 L2.2,7.7 C2.20293333,7.4932 2.04013333,7.32966667 1.83333333,7.33333333 Z",
    id: "Shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingIcon);
export default __webpack_public_path__ + "static/media/building-icon.658c2ae241c4662f407d2e1761cd5e34.svg";
export { ForwardRef as ReactComponent };